/**
 * Variant Image Filter for Shopify Heritage Theme v10
 * 
 * Desktop (grid mode): CSS injection по data-media-id — без disconnectedCallback
 * Mobile (slider mode): DOM manipulation как Rubik — с disconnectedCallback
 */

(function () {
  'use strict';

  var originalSlides = [];
  var originalDots = [];
  var originalThumbnails = [];
  var currentColor = null;
  var isFiltering = false;

  // CSS-стиль для grid-режима
  var gridStyle = document.createElement('style');
  gridStyle.id = 'vif-grid-style';
  document.head.appendChild(gridStyle);

  function cleanAlt(img) {
    return (img.getAttribute('alt') || '')
      .replace(/['""\u201C\u201D\u00AB\u00BB]/g, '')
      .toLowerCase()
      .trim();
  }

  function shouldHide(element, targetColor) {
    var img = element.querySelector('img');
    if (!img) return false;
    var alt = cleanAlt(img);
    if (!alt.startsWith('#color_')) return false;
    return alt.replace('#color_', '') !== targetColor;
  }

  /**
   * Собрать media-id которые нужно скрыть
   */
  function getMediaIdsToHide(targetColor) {
    var mg = document.querySelector('media-gallery');
    if (!mg) return [];

    var hideIds = [];
    mg.querySelectorAll('[data-media-id]').forEach(function (div) {
      var img = div.querySelector('img');
      if (!img) return;
      var alt = cleanAlt(img);
      if (alt.startsWith('#color_') && alt.replace('#color_', '') !== targetColor) {
        var id = div.getAttribute('data-media-id');
        if (hideIds.indexOf(id) === -1) hideIds.push(id);
      }
    });

    return hideIds;
  }

  /**
   * GRID MODE (Desktop): Скрываем через CSS — безопасно, не ломает Heritage
   */
  function filterGrid(targetColor) {
    var hideIds = getMediaIdsToHide(targetColor);

    if (hideIds.length === 0) {
      gridStyle.textContent = '';
      return;
    }

    var css = hideIds.map(function (id) {
      return [
        // Скрыть в grid
        '.product-media-container:has([data-media-id="' + id + '"]) { display: none !important; }',
        // Скрыть slideshow-slide (если есть скрытый слайдер)
        'slideshow-slide:has([data-media-id="' + id + '"]) { display: none !important; }',
        // Скрыть миниатюры
        'button[data-media-id="' + id + '"] { display: none !important; }',
        '[data-thumbnail-id="' + id + '"] { display: none !important; }',
        // Скрыть в zoom
        '.dialog-thumbnails-list__thumbnail:has([data-media-id="' + id + '"]) { display: none !important; }'
      ].join('\n');
    }).join('\n');

    gridStyle.textContent = css;
    console.log('[VIF] Grid CSS: скрыто ids:', hideIds);
  }

  /**
   * SLIDER MODE (Mobile): DOM manipulation как Rubik
   */
  function filterSlider(targetColor) {
    var comp = document.querySelector('media-gallery slideshow-component');
    if (!comp) return;

    var scroller = comp.refs?.scroller || comp.querySelector('slideshow-slides');
    if (!scroller) return;

    var slides = comp.refs?.slides;
    if (!slides || slides.length === 0) {
      slides = Array.from(scroller.querySelectorAll('slideshow-slide'));
      if (comp.refs) comp.refs.slides = slides;
    }
    if (!slides || slides.length === 0) return;

    var newSlides = [];

    if (originalSlides.length === 0) {
      originalSlides = Array.from(slides).map(function (s) { return s.cloneNode(true); });

      slides.forEach(function (slide) {
        if (shouldHide(slide, targetColor)) {
          slide.remove();
        } else {
          slide.setAttribute('aria-hidden', 'false');
          newSlides.push(slide);
        }
      });
    } else {
      scroller.innerHTML = '';
      if (comp.refs) comp.refs.slides = [];

      originalSlides.forEach(function (slide) {
        if (!shouldHide(slide, targetColor)) {
          var clone = slide.cloneNode(true);
          clone.setAttribute('aria-hidden', 'false');
          newSlides.push(clone);
          scroller.appendChild(clone);
        }
      });
    }

    if (comp.refs) comp.refs.slides = newSlides;
    if (scroller) scroller.scrollTo({ top: 0, left: 0, behavior: 'instant' });

    fixDots(comp, newSlides.length);
    fixTotalCounter(comp, newSlides.length);
    fixThumbnails(targetColor);
  }

  function fixDots(comp, count) {
    var dots = comp.refs?.dots;
    var dotsCtrl = comp.refs?.slideshowControls?.querySelector('.slideshow-controls__dots');
    var newDots = [];

    if (originalDots.length === 0 && dots && dots.length > 0) {
      originalDots = Array.from(dots).map(function (d) {
        var p = d.parentNode;
        return (p && p.tagName === 'LI') ? p.cloneNode(true) : d.cloneNode(true);
      });
      dots.forEach(function (d, i) {
        if (i >= count) { if (d.parentNode) d.parentNode.remove(); }
        else newDots.push(d);
      });
    } else if (dotsCtrl) {
      dotsCtrl.innerHTML = '';
      originalDots.forEach(function (od, i) {
        if (i < count) {
          var c = od.cloneNode(true);
          var btn = c.tagName === 'LI' ? (c.querySelector('button') || c) : c;
          btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
          dotsCtrl.appendChild(c);
          newDots.push(btn);
        }
      });
    }
    if (comp.refs) comp.refs.dots = newDots;
  }

  function fixTotalCounter(comp, count) {
    var cur = comp.refs?.current;
    var tc = comp.querySelector('.slideshow-controls__counter');
    if (tc && tc.lastChild) tc.lastChild.textContent = count.toString();
    if (cur) cur.textContent = '1';
  }

  function fixThumbnails(targetColor) {
    var comp = document.querySelector('media-gallery slideshow-component');
    if (!comp) return;
    var thumbs = comp.refs?.thumbnails;
    if ((!thumbs || thumbs.length === 0) && originalThumbnails.length === 0) return;

    var container = comp.refs?.thumbnailsContainer?.querySelector('.slideshow-controls__thumbnails');
    var newT = [];

    if (originalThumbnails.length === 0 && thumbs && thumbs.length > 0) {
      originalThumbnails = Array.from(thumbs).map(function (t) { return t.cloneNode(true); });
      var idx = 0;
      thumbs.forEach(function (t) {
        if (shouldHide(t, targetColor)) t.remove();
        else {
          t.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
          t.setAttribute('on:click', '/select/' + idx);
          newT.push(t); idx++;
        }
      });
    } else if (container) {
      container.innerHTML = '';
      var idx = 0;
      originalThumbnails.forEach(function (t) {
        if (!shouldHide(t, targetColor)) {
          var c = t.cloneNode(true);
          c.setAttribute('aria-selected', idx === 0 ? 'true' : 'false');
          c.setAttribute('on:click', '/select/' + idx);
          container.appendChild(c);
          newT.push(c); idx++;
        }
      });
    }
    if (comp.refs) comp.refs.thumbnails = newT;
  }

  /**
   * Главная функция — определяет режим и вызывает соответствующий фильтр
   */
  function applyFilter() {
    if (!currentColor || isFiltering) return;
    isFiltering = true;

    var mg = document.querySelector('media-gallery');
    if (!mg) { isFiltering = false; return; }

    // Защита Judge.me
    var savedJdgm = null;
    if (window.jdgm && typeof window.jdgm.eachRevWidgets === 'function') {
      savedJdgm = window.jdgm.eachRevWidgets;
      window.jdgm.eachRevWidgets = function () {};
    }

    try {
      var targetColor = currentColor.toLowerCase().trim();
      var isMobile = window.innerWidth < 768;

      // CSS фильтрация — всегда применяем (работает для grid на десктопе)
      filterGrid(targetColor);

      if (isMobile) {
        // Мобильная: DOM manipulation для слайдера
        if (!mg.hasAttribute('vif-filtered')) {
          if (typeof mg.disconnectedCallback === 'function') {
            mg.disconnectedCallback();
          }
          mg.setAttribute('vif-filtered', 'true');
        }
        filterSlider(targetColor);
      }
    } finally {
      if (savedJdgm && window.jdgm) {
        setTimeout(function () { window.jdgm.eachRevWidgets = savedJdgm; }, 500);
      }
      isFiltering = false;
    }

    console.log('[VIF] Фильтр: ' + currentColor + ' (mobile: ' + (window.innerWidth < 768) + ')');
  }

  function init() {
    var vp = document.querySelector('variant-picker');
    if (!vp) return;

    var fieldsets = vp.querySelectorAll('fieldset');
    var colorFieldset = null;

    fieldsets.forEach(function (fs) {
      var legend = fs.querySelector('legend');
      if (legend && legend.textContent.trim().toLowerCase().startsWith('color')) {
        colorFieldset = fs;
      }
    });

    if (!colorFieldset) {
      console.log('[VIF] Опция Color не найдена');
      return;
    }

    var checked = colorFieldset.querySelector('input[type="radio"]:checked');
    if (checked) currentColor = checked.value;

    // Event delegation — переживёт перерисовку Heritage
    document.body.addEventListener('change', function (e) {
      if (!e.target || e.target.type !== 'radio') return;
      var fs = e.target.closest('fieldset');
      if (!fs) return;
      var legend = fs.querySelector('legend');
      if (!legend || !legend.textContent.trim().toLowerCase().startsWith('color')) return;

      currentColor = e.target.value;
      applyFilter();
    });

    // Начальная фильтрация
    applyFilter();

    console.log('[VIF] Инициализирован, цвет: ' + currentColor);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(init, 500); });
  } else {
    setTimeout(init, 500);
  }
})();